import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
import { z } from "zod";
import { ensureElementVisible } from "@/lib/route-guards";

const ApteneoPorownaniePage = lazy(() =>
	import("@/features/apteneo/porownanie-page").then((m) => ({
		default: m.ApteneoPorownaniePage,
	})),
);

// Okres i zakres aptek deep-linkowalne; `.catch()` na kazdym polu — zly param ze
// starej zakladki nie moze wywalic trasy ZodErrorem (FARMASTER-FRONTEND-31/33/34).
// Niepoprawny `scope` odrzuca dopiero `useScopeWithTree` (sanity wobec drzewa).
const searchSchema = z.object({
	rok: z.number().int().min(2000).max(2100).optional().catch(undefined),
	kwartal: z.number().int().min(1).max(4).optional().catch(undefined),
	scope: z.string().optional().catch(undefined),
	ukryjNieporownywalne: z.boolean().optional().catch(undefined),
});

export type ApteneoPorownanieSearch = z.infer<typeof searchSchema>;

export const Route = createFileRoute("/_auth/apteneo/porownanie")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.apteneo.porownanie",
			location.pathname,
		);
	},
	component: ApteneoPorownaniePage,
	validateSearch: (search: Record<string, unknown>): ApteneoPorownanieSearch =>
		searchSchema.parse(search),
});
